<template>
  <div>
    <div class="modal inmodal" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div :class="'modal-content ' + animation">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
            <h4 class="modal-title">
              <slot name="title"></slot>
            </h4>
            <slot name="description"></slot>
          </div>
          <div class="modal-body">
            <slot name="form"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Form',
  props: ['modalId', 'animation']
}
</script>

<style scoped>
.fc-label {
  background: #f8fafb !important;
  border: 0px !important;
}
.center {
  text-align: center;
}
.bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Helpers/Modal/Form.vue